import React from "react";
import { Button } from "@src/components/button/Button";
import styles from "./ErrorBoundary.module.scss";

const CHUNK_RELOAD_KEY = "chunkLoadErrorReloaded";

const isChunkLoadError = (error: Error) =>
	error.name === "ChunkLoadError" || /Loading (CSS )?chunk [\w-]+ failed/i.test(error.message);

interface IErrorBoundaryProps {
	children: React.ReactNode;
	resetKey?: string;
}

interface IErrorBoundaryState {
	hasError: boolean;
}

export class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {
	state: IErrorBoundaryState = { hasError: false };

	static getDerivedStateFromError(): IErrorBoundaryState {
		return { hasError: true };
	}

	componentDidCatch(error: Error) {
		if (!isChunkLoadError(error)) return;

		try {
			if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) return;
			sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
		} catch {
			return;
		}

		window.location.reload();
	}

	componentDidUpdate(prevProps: IErrorBoundaryProps) {
		if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) this.setState({ hasError: false });
	}

	render() {
		if (!this.state.hasError) return this.props.children;

		return (
			<div className={styles.root}>
				<div className={styles.title}>Something went wrong</div>
				<div className={styles.text}>Please reload the page to continue.</div>
				<Button onClick={() => window.location.reload()}>Reload</Button>
			</div>
		);
	}
}
